import { Button, Tab, Tabs } from 'react-bootstrap';
import SvgSave from 'components/svg/SvgSave';
import spinnerTitle from 'components/others/spinnerTitle';
import { useTranslation } from 'react-i18next';
import UserTabGeneral from './Tabs/UserTabGeneral';
import useDeleteUser from './hooks/hookDeleteUser';
import * as apiUser from 'api/apiUsers';
import { useToast } from 'context/ToastContext';
import { useAuth } from 'context/AuthContext';
import UserTabAccess from './Tabs/UserTabAccess';
import UserTabTelegram from './Tabs/UserTabTelegram';
import type { UserCardTabsProps } from '../types';

const UserCardTabs = ({
    isSaving,
    user,
    setShowUserCard,
    fetchUsers,
    dispatchUser,
    setShowSpinner,
}: UserCardTabsProps) => {
    const { t } = useTranslation();
    const { auth } = useAuth();
    const { showToast } = useToast();
    const deleteUser = useDeleteUser();

    const cbDeleteUser = async () => {
        setShowUserCard(false);
        setShowSpinner(true);
        const resDel = await apiUser.deleteUser(user.ID);
        if (!resDel) showToast(t('messError'), 'danger');
        else showToast(t('Users.messDeleted'), 'success');

        await fetchUsers(true);
    };

    return (
        <div className="off-user-card-tabs d-flex flex-column h-100">
            <div className="off-user-card-tabs-content px-3">
                <Tabs variant="underline" defaultActiveKey="base" className="mb-3 invoice-tab border-bottom">
                    <Tab
                        eventKey="base"
                        title={
                            <>
                                <i className="bi bi-gear me-2 fs-14"></i>
                                {t('Users.tabUserCardGeneral')}
                            </>
                        }>
                        <UserTabGeneral user={user} dispatchUser={dispatchUser} />
                    </Tab>

                    <Tab
                        eventKey="access"
                        title={
                            <>
                                <i className="bi bi-lock me-2 fs-14"></i>
                                {t('Users.tabUserCardAccess')}
                            </>
                        }>
                        <UserTabAccess user={user} dispatchUser={dispatchUser} />
                    </Tab>

                    <Tab
                        eventKey="telegram"
                        title={
                            <>
                                <i className="bi bi-telegram me-2 fs-14"></i>
                                {t('Users.tabUserCardTelegram')}
                            </>
                        }>
                        <UserTabTelegram user={user} dispatchUser={dispatchUser} />
                    </Tab>
                </Tabs>
            </div>
            <div className="p-3 offcanvas-footer off-user-card-tabs-footer">
                <div className="d-flex justify-content-between">
                    <div>
                        {/**
                        {user.ID !== 0 && user.ID !== auth.user.ID && (
                            <Button className="me-1" variant="danger" onClick={() => deleteUser(cbDeleteUser)}>
                                <i className="bi bi-trash fs-14 me-md-2"></i>
                                <span className="d-none d-md-inline">{t('buttons.delete')}</span>
                            </Button>
                        )} */}
                    </div>
                    <div className="text-end">
                        <Button className="me-1" variant="secondary" onClick={() => setShowUserCard(false)}>
                            {t('buttons.cancel')}
                        </Button>
                        <Button type="submit" variant="info" className="min100px">
                            {spinnerTitle(
                                <>
                                    <SvgSave className="me-2 mtop-2" />
                                    {t('buttons.save')}
                                </>,
                                isSaving,
                                t('buttons.saving'),
                            )}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default UserCardTabs;
